import { Fragment, ReactElement, useMemo } from 'react';
import { CohabitationDetailNotificationsCrumbs } from 'notifications-from-civil-status/constants/breadcrumb';
import { IdAmbito } from 'shell/constants/id-ambito';
import { CohabitationDetailNotificationsSubscriptionCrumbs } from 'subscription/constants/breadcrumb';
import { CohabitationDetailNotificationsMutationCrumbs } from 'mutation/constants/research-notifications-civil-status.crumbs';
import { CohabitationDetailNotificationsCancellationsCrumbs } from 'cancellations/constants/breadcrumb';
import { getBaseUrl } from 'notifications-from-civil-status/utils/get-base-url';
import { useParams } from 'react-router-dom';
import { CohabitationDetailNotificationsCivilStatusCrumbs } from 'civil-status/constants/breadcrumb';
import RegisterCohabitationNotificationShared from 'shell/components/shared/research-notifications/research-cohabitation/detail';

interface RegisterCohabitationNotificationCivilStatusSharedProps {
  scope?: string;
  isOther?: boolean;
}

const RegisterCohabitationNotificationCivilStatusShared = ({
  scope,
  isOther,
}: RegisterCohabitationNotificationCivilStatusSharedProps): ReactElement => {
  const params = useParams();

  const idAnsc = useMemo(() => {
    return params.id || undefined;
  }, [params.id]);
  const idNotifica = params.idNotifica || '';
  const idCat = params.idCat || undefined;

  const baseUrl: string = useMemo(() => {
    return getBaseUrl(scope, idCat);
  }, [scope, idCat]);

  const goBackUrl: string = useMemo(() => {
    return `${baseUrl}/modifica/${idAnsc}/${idNotifica}`;
  }, [baseUrl, idAnsc, idNotifica]);

  const goBackUrlDetail: string = useMemo(() => {
    return `${baseUrl}/visualizza/${idAnsc}/${idNotifica}`;
  }, [baseUrl, idAnsc, idNotifica]);

  const items = useMemo(() => {
    if (idCat) {
      return CohabitationDetailNotificationsCivilStatusCrumbs(goBackUrl, idCat);
    }

    if (!scope) {
      return CohabitationDetailNotificationsCrumbs(goBackUrl);
    }

    switch (scope) {
      case IdAmbito.Iscrizioni:
        return CohabitationDetailNotificationsSubscriptionCrumbs(goBackUrl);
      case IdAmbito.Mutazioni:
        return CohabitationDetailNotificationsMutationCrumbs(goBackUrl);
      case IdAmbito.Cancellazioni:
        return CohabitationDetailNotificationsCancellationsCrumbs(goBackUrl);
      default:
        return [];
    }
  }, [scope, idCat]);

  return (
    <Fragment>
      <RegisterCohabitationNotificationShared
        goBackUrl={goBackUrl}
        items={items}
        isOther={isOther}
        goBackUrlDetail={goBackUrlDetail}
      />
    </Fragment>
  );
};

RegisterCohabitationNotificationCivilStatusShared.displayName =
  'Research Cohabitation Notifications Detail Page component';

export default RegisterCohabitationNotificationCivilStatusShared;
